import { useAction, useAtom } from '@reatom/npm-react'
import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Transaction } from '@root/entities/transaction'

import { TransactionsFilter } from './transactions-filter'

import type { UserTransactionsModel } from '@root/features/user/transaction-history'

type Props = {
  model: UserTransactionsModel
}
export const TransactionsStatusFilter = ({ model }: Props) => {
  const { t } = useTranslation()
  const [statusFilterOpen, setStatusFilterOpen] = useState(false)

  const [statusFilter] = useAtom(model.statusFilter)
  const setStatusFilter = useAction(model.setStatusFilter)

  const options = useMemo(
    () => [
      { label: t('transaction.status_all'), value: undefined },
      ...Transaction.txStatuses.map((status) => ({
        label: t(`transaction.status_${status}`),
        value: status,
      })),
    ],
    [t],
  )

  return (
    <TransactionsFilter
      options={options}
      value={statusFilter}
      onChange={(s) => setStatusFilter(s)}
      open={statusFilterOpen}
      onOpenChange={setStatusFilterOpen}
    />
  )
}
